import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACK_URL || `${window.location.protocol}//${window.location.hostname}:5050`;

export const getQR = async () => {
  const res = await axios.get(`${API_BASE}/whatsapp/qr`);
  return res.data;
};

export const getStatus = async () => {
  const res = await axios.get(`${API_BASE}/whatsapp/status`);
  return res.data;
};

export const connect = async () => {
  const res = await axios.post(`${API_BASE}/whatsapp/connect`);
  return res.data;
};

export const getChats = async () => {
  const res = await axios.get(`${API_BASE}/whatsapp/chats`);
  return res.data;
};

export const searchChats = async (q: string) => {
  const res = await axios.get(`${API_BASE}/whatsapp/chats/search`, { params: { q } });
  return res.data;
};

export const getMessages = async (chatId: string, limit = 50) => {
  const res = await axios.get(`${API_BASE}/whatsapp/chats/${encodeURIComponent(chatId)}/messages`, {
    params: { limit },
  });
  return res.data;
};

export const sendMessage = async (phone: string, message: string) => {
  const res = await axios.post(`${API_BASE}/whatsapp/send`, { phone, message });
  return res.data;
};

export const getDebugInfo = async () => {
  const res = await axios.get(`${API_BASE}/whatsapp/debug`);
  return res.data;
};

export const disconnect = async () => {
  const res = await axios.post(`${API_BASE}/whatsapp/disconnect`);
  return res.data;
};
